import { PageInfoModel } from '../../pipe-pagination/page-info.model';

export class HeadhunterFilterModel {
    area: Array<string>;
    funcao: Array<string>;
    nivel: Array<string>;
    uf: Array<string>;
    status: Array<string>;
    filterDetail: boolean;
    after: string;
    before: string;
    pageSize: PageInfoModel
}
